export const environment = {
  production: true,
  apiUrl: 'https://explorer-api.innerloop.software/api',
  auth0Domain: 'auth.loop.software',
  auth0ClientId: 'jAj1a6QMpVtZWG7IIb1NbWaAMpObX9ui',
  auth0Audience: 'https://explorer.loop.software',
};
